export const REQUEST_PARTNER_STATUS = 'zola/user/REQUEST_PARTNER_STATUS';
export const RECEIVE_PARTNER_STATUS = 'zola/user/RECEIVE_PARTNER_STATUS';
